<template>
  <div class="national-bottom-center">
    <div :style="{ width: '100%', height: '100%' }" v-if="!nodata">
      <div
        id="bottomCenter"
        class="chartCanvas"
        v-loading="loading"
        :style="{ width: '100%', height: '100%' }"
      ></div>
    </div>
    <div
      class="no-data flex-center"
      v-else
      :style="{ width: '100%', height: '100%' }"
    >
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [],
      legendData: [],
      seriesData: [],
      show: false,
      chartData: [],
      chartSeriesData: [],
      nodata: false,
      loading: true,
      colors: []
    };
  },
  //方法集合
  methods: {
    // 获取报表数据
    async getLossRate() {
      let chartData = [];
      let chartSeriesData = [];
      let res = await this.$api.getLossRate();
      if (res.data.length > 0) {
        this.nodata = false;
        // 设置数据
        res.data.map(item => {
          chartData.push(item.name);
          chartSeriesData.push({
            value: (item.rate * 100).toFixed(2),
            name: item.name
          });
        });
        this.chartData = chartData;
        this.chartSeriesData = chartSeriesData;
        this.$nextTick(() => {
          this.loading = false;
          this.initEchart();
        });
      } else {
        this.nodata = true;
      }
    },
    initEchart() {
      const mapChart = this.$oecharts.init(
        document.getElementById("bottomCenter")
      );
      if (mapChart) {
        mapChart.showLoading();
        mapChart.hideLoading();

        mapChart.setOption({
          title: {
            padding: 5,
            text: "鱼病比例图",
            x: "center",
            textStyle: {
              color: "#fff",
              fontWeight: 400
            }
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} <br/> 所占比:{d}%",
            position: "right"
          },
          animation: false, // 禁止浮动
          graphic: [
            {
              type: "text",
              left: "center",
              top: "center",
              style: {
                textAlign: "center",
                fill: "#000",
                color: "#666666",
                font: "16px Microsoft YaHei"
              }
            }
          ],
          legend: {
            tooltip: {
              trigger: "item",
              show: true
            },
            left: "left",
            top: "top",
            height: 220,
            textStyle: {
              color: "rgba(255,255,255,1)",
              fontSize: 12,
              fontFamily: "Microsoft YaHei",
              padding: 0
            },
            orient: "vertical",
            y: "center",
            data: this.chartData
          },
          series: [
            {
              type: "pie",
              radius: "30%",
              center: ["50%", "40%"],
              minAngle: 15,
              label: {
                show: true,
                formatter: "{b}",
                fontSize: 12,
                color: "rgba(255,255,255,1)",
                padding: -10
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              },
              data: this.chartSeriesData
            }
          ]
        });
        window.addEventListener("resize", function() {
          mapChart.resize();
        });
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getLossRate();
    this.loading = false;
    this.initEchart();
  }
};
</script>
<style lang="stylus" scoped>
.no-data {
  span {
    color: #fff;
    font-size: 0.18rem;
  }
}
.national-bottom-center {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
